module.exports = __webpack_public_path__ + "static/dream_world-426c3f3d9492f14805a2de9b3f55f3aa.gif";